const hotelTypes = [
    { key: '9', value: 'HEA', text: 'Hotel El Alcaravan' },
    { key: '10', value: 'HBO', text: 'Hotel Bosques de Athan' },
    { key: '11', value: 'HCA', text: 'Cantu Glamping y Cabañas' },
    { key: '12', value: 'HCO', text: 'Hotel Colonial' },
    { key: '13', value: 'HLN', text: 'Hotel Lanceros' },
    { key: '14', value: 'HPE', text: 'Hotel Peñalisa' }
  ];
  
  export default hotelTypes;
  